export default __webpack_public_path__ + "static/media/arrow-right.8ed22f7d.svg";